import {useEffect} from "react";

const PaymentOk = () => {
    useEffect(() => {
        localStorage.removeItem("CartItems");
    }, []);

    return (
        <div>
            <div className="flex items-center justify-center">
                <h1 className="p-[10%] text-[1rem] lg:text-[2rem] font-bold tracking-wide text-headingColor text-center">
                    Заказ оформлен.
                </h1>
            </div>
            <div className="flex items-center justify-center">
                <h1 className="p-[10%] text-[1rem] lg:text-[2rem] font-bold tracking-wide text-headingColor text-center">
                    Ресторан с вами свяжется в ближайшее время.
                </h1>
            </div>
        </div>
    );
}

export default PaymentOk;